<template>
  <div
    class="full-screen"
    :style="{
      ...position,
      ...bgImgStyle,
      ...customStyle,
    }"
    :class="[isEmpty(position) ? '' : 'absolute-el']"
    @click="toggle()"
  />
</template>

<script setup lang="ts">
import { isEmpty } from "lodash-es"
import { api as fullscreenAPI } from "vue-fullscreen"
import { ref, computed } from "vue"

type FullscreenOptions = {
  expand: {
    img: string
    style: any
  }
  closed: {
    img: string
    style: any
  }
}

type FullscreenComponent = {
  position?: any
  options?: FullscreenOptions
  customStyle?: any
}

const props = withDefaults(defineProps<FullscreenComponent>(), {
  position: () => ({}),
  options: () => ({
    expand: {
      img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADTSURBVHgB5ZTLDcIwDIadqFt0EO5sUOaAaWAO2CB32IABMkewkS25JsUlVQ8Vv1SlduwvLycAW1OQn1JKwqavxOQQwl475sR2ykmBD/zuNrgCOBvwge3PwXAWT/yO8KMw58S5iVrxR1gggmJDk6EVXHVfM1hDcV8vtr8J7EEtOEP9oCx0mIDOyv8G7hn+b6Jl0/KhVVzgg/FJ8bt7yhNIYuuqGF1JU1I38DXKjxOju3XqKa4BJXXGlldqEbQGJuj79qiXLts95sO0lbLTxmoP/fb0AnbOha+ZzWd6AAAAAElFTkSuQmCC",
      style: {
        width: "22px",
        height: "22px",
      },
    },
    closed: {
      img: "data:image/png;base64,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",
      style: {
        width: "22px",
        height: "22px",
      },
    },
  }),
  customStyle: () => ({}),
})

const fullscreen = ref<boolean>(false)

const toggle = function () {
  fullscreen.value = !fullscreen.value
  fullscreenAPI.toggle()
}

const bgImgStyle = computed(() => {
  const expand = props.options && props.options.expand
  const closed = props.options && props.options.closed
  const stateImg = fullscreen.value ? closed.img : expand.img
  const stateStyle = fullscreen.value ? closed.style : expand.style
  return {
    backgroundImage: `url(${stateImg})`,
    ...stateStyle,
  }
})
</script>

<style scoped lang="scss">
.full-screen {
  cursor: pointer;
  height: 24px;
  width: 24px;
  background-size: contain;
}
</style>
